export default {
    funcionalidades: { method: 'GET', url: 'funcionalidade/ativos' },
    gravar: { method: 'POST', url: 'usuario/funcionalidade' },
    
};